import React, { useState, useEffect } from "react";
import "../styles/Settings.css";
import { useLocation } from "react-router-dom";
import ProfileSection from "./User-profiles/UserProfilePage";
import ChangePassword from "./User-profiles/ChangePassword";
import Security from "./User-profiles/Security";
import DisplayPreferences from "./User-profiles/DisplayPreferences";
// import UpdateTheme from "./user-profiles/UpdateTheme";
// import Security from "./user-profiles/Security";
// import { SessionCheck } from "../utils/SessionCheckUtils";
// import { useCheckSessionHeartBeat } from "../utils/ApiUtils";

// Define the shape of each tab
interface Tab {
  label: string;
  content: React.ReactNode;
}

// Define the shape of location.state (if any)
interface LocationState {
  activeTab?: number;
}

// Tabs definition
const tabs: Tab[] = [
  { label: "Profile Setting", content: <ProfileSection /> },
  // { label: "Change Password", content: <ChangePassword /> },
  { label: "Data and Security", content: <Security /> },
  { label: "Display Preferences", content: <DisplayPreferences /> },
  //   { label: "Security", content: <Security /> },
  //   { label: "Display and Theme", content: <UpdateTheme /> },
];

const Settings: React.FC = () => {
  //   useCheckSessionHeartBeat();
  //   const isSessionValid = SessionCheck();
  const [activeTab, setActiveTab] = useState<number>(0);

  const location = useLocation();
  const locationState = location.state as LocationState | null;

  useEffect(() => {
    if (locationState?.activeTab !== undefined) {
      setActiveTab(locationState.activeTab);
    }
  }, [locationState]);

  //   if (!isSessionValid) {
  //     return null;
  //   }

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className="settings-main">
      <div className="settings-container">
        <div className="tabs">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`tab ${activeTab === index ? "active" : ""}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className="content">{tabs[activeTab].content}</div>
      </div>
    </div>
  );
};

export default Settings;
